import { create } from 'zustand'
import { Auth as aws } from 'aws-amplify'

const AuthStoreInit = {
  isLoggedIn: false,
  token: null
}

export const useAuthStore = create<IAuthStore>(set => ({
  ...AuthStoreInit,
  logIn: async () => {
    const session = await aws.currentSession()
    const token = session?.getIdToken?.()?.getJwtToken?.()
    set(() => {
      if (Boolean(token)) {
        return {
          isLoggedIn: true,
          token
        }
      } else {
        return {
          isLoggedIn: false,
          token: null
        }
      }
    })
  },
  logOut: () =>
    set(() => {
      aws.signOut()
      return {
        isLoggedIn: false,
        token: null
      }
    })
}))

export interface IAuthStore {
  isLoggedIn: boolean
  token: string | null
  logIn: () => void
  logOut: () => void
}
